import { render, staticRenderFns } from "./Benutzerverwaltung.vue?vue&type=template&id=2726aff2&"
import script from "./Benutzerverwaltung.vue?vue&type=script&lang=js&"
export * from "./Benutzerverwaltung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports